import App from 'app/app.js';
import 'app/service/EventService.js';

function SessionRecreatedAction(EventService) {
  this.eventName = 'sessionRecreatedAction';

  this.dispatch = function () {
    EventService.dispatch(this.eventName, {});
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('SessionRecreatedAction', ['EventService', SessionRecreatedAction]);
